
export default {
    name: "card-loader",
};
